var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8592 54.6036L54.6036 48.8592L63.1796 57.4757L71.7557 48.8592L77.5 54.6036L68.8835 63.1796L77.5 71.7557L71.7557 77.5L63.1796 68.8835L54.6036 77.5L48.8592 71.7557L57.4757 63.1796L48.8592 54.6036ZM38.9078 59.1343V51.0437H18.6812V59.1343H38.9078ZM59.1343 34.8625H18.6812V42.9531H49.7896C46.4426 45.1596 43.696 48.1629 41.7966 51.6933C39.8973 55.2237 38.9046 59.1707 38.9078 63.1796C38.9078 67.589 40.0809 71.7557 42.144 75.3155H10.5906C8.44485 75.3155 6.38697 74.4631 4.86969 72.9458C3.3524 71.4286 2.5 69.3707 2.5 67.2249V10.5906C2.5 6.10032 6.10032 2.5 10.5906 2.5H67.2249C69.3707 2.5 71.4286 3.3524 72.9458 4.86969C74.4631 6.38697 75.3155 8.44485 75.3155 10.5906V42.144C71.7557 40.0809 67.589 38.9078 63.1796 38.9078L59.1343 39.2314V34.8625ZM59.1343 26.7718V18.6812H18.6812V26.7718H59.1343Z",
    fill: "#FF1F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.8fcc764bf0dcfe174d948c15b920595c.svg";
export { ForwardRef as ReactComponent };